import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getMonitorIPsInItems } from "store/monitor-dashboard/monitor-dashboard-action"
import { useSearchParams } from "react-router-dom"
import MonitorIPsChartInItemsList from "components/MonitorDashboard/MonitorIPsItems/MonitorIPsChartInItems"
import { monitorDashboardAction } from "store/monitor-dashboard/monitor-dashboard-slice"

const MonitorIPsChartInItems = () => {
  const dispatch = useDispatch()

  const [searchParams] = useSearchParams()

  // get params from url parameter
  const getParams = {
    itemId: searchParams.get("itemId"),
    from: searchParams.get("from") !== "null" ? searchParams.get("from") : null,
    to: searchParams.get("to") !== "null" ? searchParams.get("to") : null,
    type: searchParams.get("type"),
    ip_id: searchParams.get("ip_id"),
  }
  const type = searchParams.get("type")
  const MonitorInItems = useSelector(
    state => state.monitorDashboard.MonitorInItems
  )

  // fetch Monitor IPs Receipt or balance based Params
  useEffect(() => {
    dispatch(getMonitorIPsInItems(getParams))

    return () => {
      dispatch(monitorDashboardAction.resetMonitorInItems())
    }
  }, [])

  return (
    // Monitor IPs Items Receipts Component
    <MonitorIPsChartInItemsList
      data={MonitorInItems?.data?.data}
      loading={MonitorInItems?.loading}
      type={type}
    />
  )
}

export default MonitorIPsChartInItems
